import { Observable } from 'rxjs'
import request from '@/utils/request'

export function getFileContentOrDownload(fileName, objectKey, type, encodeType, contentType): Observable<string> {
  return new Observable<string>((observer: any) => {
    request({ 
      method: 'GET', 
      url: `/blade-resource/oss/endpoint/file-content?fileName=${objectKey}`, 
      responseType: 'blob' 
    }).then(res => {
      if (type === 1) {
        const resCopy = res as any
        const reader = new FileReader();
        reader.onload = () => {
          observer.next(reader.result);
          observer.complete();
        }
        reader.readAsText(resCopy, encodeType)
      }
      else if (type === 2) { // blob转base64
        const resCopy = res as any
        const reader = new FileReader();
        reader.onload = () => {
          observer.next(reader.result);
          observer.complete();
        }
        reader.readAsDataURL(resCopy)
      }
    })
  })
}

export function getFileDownload(fileName, objectKey): Observable<string> {
  return new Observable<string>((observer: any) => {
    request({ 
      method: 'GET', 
      url: `/blade-resource/oss/endpoint/file-content?fileName=${objectKey}`,
      responseType: 'blob'
    }).then(res => {
      const resB = res as any
      var url = window.URL.createObjectURL(resB)
      let a = document.createElement('a')  
      a.href = url
      a.target = '_blank'
      a.download= fileName
      a.click();
    })
  })
}